/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Seo_TitleInputs */

const et_service_seo_title = /** @type {(inputs: Service_Seo_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google nähtavuse edendamine`)
};

const en_service_seo_title = /** @type {(inputs: Service_Seo_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google Visibility Promotion`)
};

/**
* | output |
* | --- |
* | "Google Visibility Promotion" |
*
* @param {Service_Seo_TitleInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const service_seo_title = /** @type {((inputs?: Service_Seo_TitleInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Seo_TitleInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_service_seo_title(inputs)
	return en_service_seo_title(inputs)
});